import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, X, Eye, Calendar, MapPin, Users, DollarSign, Building2, Clock } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/Table';
export function EventApprovalsPage() {
  const navigate = useNavigate();
  const [filter, setFilter] = useState<'all' | 'pending' | 'approved' | 'rejected'>('pending');
  const events = [{
    id: 1,
    title: 'Workshop React Advanced',
    organizer: 'Jakarta Tech Community',
    organizerType: 'chapter',
    type: 'workshop',
    date: '15 Feb 2025',
    location: 'Jakarta',
    participants: 30,
    price: 'Rp 500.000',
    status: 'pending',
    submittedDate: '10 Jan 2025'
  }, {
    id: 2,
    title: 'Seminar Digital Marketing',
    organizer: 'PT Tech Indonesia',
    organizerType: 'organisasi',
    type: 'seminar',
    date: '20 Feb 2025',
    location: 'Online',
    participants: 100,
    price: 'Gratis',
    status: 'pending',
    submittedDate: '12 Jan 2025'
  }, {
    id: 3,
    title: 'Training Cloud Computing',
    organizer: 'CV Digital Solutions',
    organizerType: 'badan_usaha',
    type: 'training',
    date: '25 Feb 2025',
    location: 'Bandung',
    participants: 25,
    price: 'Rp 1.000.000',
    status: 'pending',
    submittedDate: '13 Jan 2025'
  }, {
    id: 4,
    title: 'Webinar AI Trends 2025',
    organizer: 'Tech Partner Corp',
    organizerType: 'mitra',
    type: 'webinar',
    date: '28 Feb 2025',
    location: 'Online',
    participants: 200,
    price: 'Gratis',
    status: 'approved',
    submittedDate: '8 Jan 2025',
    approvedDate: '9 Jan 2025'
  }, {
    id: 5,
    title: 'Meetup Developer Surabaya',
    organizer: 'Surabaya Tech Hub',
    organizerType: 'chapter',
    type: 'meeting',
    date: '18 Feb 2025',
    location: 'Surabaya',
    participants: 50,
    price: 'Gratis',
    status: 'rejected',
    submittedDate: '5 Jan 2025',
    rejectedDate: '7 Jan 2025',
    rejectionReason: 'Informasi tidak lengkap'
  }];
  const filteredEvents = events.filter(event => {
    if (filter === 'all') return true;
    return event.status === filter;
  });
  const stats = [{
    label: 'Menunggu Review',
    value: events.filter(e => e.status === 'pending').length.toString(),
    icon: Clock,
    color: 'text-warning',
    bgColor: 'bg-warning-light'
  }, {
    label: 'Disetujui',
    value: events.filter(e => e.status === 'approved').length.toString(),
    icon: Check,
    color: 'text-success',
    bgColor: 'bg-success-light'
  }, {
    label: 'Ditolak',
    value: events.filter(e => e.status === 'rejected').length.toString(),
    icon: X,
    color: 'text-error',
    bgColor: 'bg-error-light'
  }];
  const getOrganizerBadge = (type: string) => {
    switch (type) {
      case 'chapter':
        return <Badge variant="primary" data-id="element-2020">Chapter</Badge>;
      case 'organisasi':
        return <Badge variant="success" data-id="element-2021">Organisasi</Badge>;
      case 'badan_usaha':
        return <Badge variant="warning" data-id="element-2022">Badan Usaha</Badge>;
      case 'mitra':
        return <Badge variant="default" data-id="element-2023">Mitra</Badge>;
      default:
        return <Badge data-id="element-2024">Komite Pusat</Badge>;
    }
  };
  const handleApprove = (eventId: number) => {
    if (confirm('Apakah Anda yakin ingin menyetujui event ini?')) {
      alert(`Event #${eventId} berhasil disetujui dan dipublikasikan!`);
    }
  };
  const handleReject = (eventId: number) => {
    const reason = prompt('Alasan penolakan:');
    if (reason) {
      alert(`Event #${eventId} ditolak. Alasan: ${reason}`);
    }
  };
  return <div className="min-h-screen bg-white" data-id="element-2025">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2026">
        {/* Header */}
        <div className="mb-8" data-id="element-2027">
          <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-2028">
            Persetujuan Event
          </h1>
          <p className="text-neutral-600" data-id="element-2029">
            Review dan setujui event yang diajukan oleh Chapter, Organisasi,
            Badan Usaha, dan Mitra
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-2030">
          {stats.map((stat, i) => <Card key={i} data-id="element-2031">
              <CardContent className="p-6" data-id="element-2032">
                <div className="flex items-center gap-4" data-id="element-2033">
                  <div className={`p-3 rounded-lg ${stat.bgColor}`} data-id="element-2034">
                    <stat.icon className={`w-6 h-6 ${stat.color}`} data-id="element-2035" />
                  </div>
                  <div data-id="element-2036">
                    <p className="text-2xl font-semibold text-neutral-900" data-id="element-2037">
                      {stat.value}
                    </p>
                    <p className="text-sm text-neutral-600" data-id="element-2038">{stat.label}</p>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>

        {/* Filter */}
        <div className="flex gap-2 mb-6" data-id="element-2039">
          <Button variant={filter === 'all' ? 'primary' : 'secondary'} onClick={() => setFilter('all')} data-id="element-2040">
            Semua
          </Button>
          <Button variant={filter === 'pending' ? 'primary' : 'secondary'} onClick={() => setFilter('pending')} data-id="element-2041">
            <Clock className="w-4 h-4 mr-2" data-id="element-2042" />
            Menunggu
          </Button>
          <Button variant={filter === 'approved' ? 'primary' : 'secondary'} onClick={() => setFilter('approved')} data-id="element-2043">
            <Check className="w-4 h-4 mr-2" data-id="element-2044" />
            Disetujui
          </Button>
          <Button variant={filter === 'rejected' ? 'primary' : 'secondary'} onClick={() => setFilter('rejected')} data-id="element-2045">
            <X className="w-4 h-4 mr-2" data-id="element-2046" />
            Ditolak
          </Button>
        </div>

        {/* Events Table */}
        <Card data-id="element-2047">
          <CardHeader data-id="element-2048">
            <CardTitle data-id="element-2049">Daftar Event</CardTitle>
          </CardHeader>
          <CardContent data-id="element-2050">
            <Table data-id="element-2051">
              <TableHeader data-id="element-2052">
                <TableRow data-id="element-2053">
                  <TableHead data-id="element-2054">Event</TableHead>
                  <TableHead data-id="element-2055">Penyelenggara</TableHead>
                  <TableHead data-id="element-2056">Tanggal</TableHead>
                  <TableHead data-id="element-2057">Lokasi</TableHead>
                  <TableHead data-id="element-2058">Peserta</TableHead>
                  <TableHead data-id="element-2059">Status</TableHead>
                  <TableHead data-id="element-2060">Diajukan</TableHead>
                  <TableHead className="text-right" data-id="element-2061">Aksi</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-2062">
                {filteredEvents.map(event => <TableRow key={event.id} data-id="element-2063">
                    <TableCell data-id="element-2064">
                      <div data-id="element-2065">
                        <p className="font-medium text-neutral-900" data-id="element-2066">
                          {event.title}
                        </p>
                        <p className="text-xs text-neutral-500" data-id="element-2067">{event.type}</p>
                      </div>
                    </TableCell>
                    <TableCell data-id="element-2068">
                      <div className="space-y-1" data-id="element-2069">
                        <p className="text-sm text-neutral-900" data-id="element-2070">
                          {event.organizer}
                        </p>
                        {getOrganizerBadge(event.organizerType)}
                      </div>
                    </TableCell>
                    <TableCell className="text-sm text-neutral-600" data-id="element-2071">
                      {event.date}
                    </TableCell>
                    <TableCell className="text-sm text-neutral-600" data-id="element-2072">
                      {event.location}
                    </TableCell>
                    <TableCell className="text-sm text-neutral-600" data-id="element-2073">
                      {event.participants}
                    </TableCell>
                    <TableCell data-id="element-2074">
                      <Badge variant={event.status === 'pending' ? 'warning' : event.status === 'approved' ? 'success' : 'error'} data-id="element-2075">
                        {event.status === 'pending' ? 'MENUNGGU' : event.status === 'approved' ? 'DISETUJUI' : 'DITOLAK'}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-sm text-neutral-600" data-id="element-2076">
                      {event.submittedDate}
                    </TableCell>
                    <TableCell className="text-right" data-id="element-2077">
                      <div className="flex justify-end gap-2" data-id="element-2078">
                        <Button size="sm" variant="ghost" onClick={() => navigate(`/events/${event.id}`)} data-id="element-2079">
                          <Eye className="w-4 h-4" data-id="element-2080" />
                        </Button>
                        {event.status === 'pending' && <>
                            <Button size="sm" variant="secondary" onClick={() => handleApprove(event.id)} className="text-success hover:text-success" data-id="element-2081">
                              <Check className="w-4 h-4" data-id="element-2082" />
                            </Button>
                            <Button size="sm" variant="secondary" onClick={() => handleReject(event.id)} className="text-error hover:text-error" data-id="element-2083">
                              <X className="w-4 h-4" data-id="element-2084" />
                            </Button>
                          </>}
                      </div>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </div>
    </div>;
}